import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  fullPageHeight: {
    height: '100%',
  },
  startPageContainer: {
    height: '100%',
    minHeight: 700,
    position: 'relative'
  },
  buldingContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    width: '100%',
    zIndex: -1,
    '& > img': {
      width: '100%',
      maxHeight: 550,
      position: 'absolute',
      bottom: 0,
      left: 0,
    }
  },
  imgBlur: {
    filter: 'blur(8px)',
    '-webkit-filter': 'blur(8px)',
  }
}));
